import React from 'react';
import PropTypes from 'prop-types';
import { get, findIndex } from 'lodash';
import { connect } from 'react-redux';
import {
  openAudienceSegmentWindow,
  deleteAudienceSegment
} from '../../../actions/audience-segment-actions';
import { defaultActionsForMapDispatchToProps } from '../../../utils/redux';

import './styles/SegmentFilter.css';

class SegmentFilter extends React.Component {
  state = {
    selectedSegment: this.props.selectedSegment
  };

  handleSelectSegment = segment => {
    this.setState({ selectedSegment: segment }, () =>
      this.props.onChange([segment])
    );
  };

  handleDeleteSegment = () => {
    const deletedSegment = this.props.onClickDeleteSegment(
      this.state.selectedSegment.uuid
    );

    const indexOfDeleted = findIndex(
      this.props.options,
      option => option.uuid === this.state.selectedSegment.uuid
    );

    const nextSegment = get(
      this.props.options,
      this.props.options.length - 1 >= indexOfDeleted
        ? indexOfDeleted + 1
        : indexOfDeleted - 1,
      { name: 'Segment', uuid: '' }
    );

    if (deletedSegment) this.setState({ selectedSegment: nextSegment });
  };

  render() {
    return (
      <div className={this.props.className}>
        <button
          className="tvt-create-segment"
          onClick={() => this.props.onClickCreateNewSegment(null, '', [])}
        >
          {this.props.title}
        </button>
      </div>
    );
  }
}

SegmentFilter.propTypes = {
  classNamePrefix: PropTypes.string,
  className: PropTypes.string,
  components: PropTypes.shape({}),
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  selectedSegment: PropTypes.shape({}),
  onClickCreateNewSegment: PropTypes.func.isRequired,
  onClickDeleteSegment: PropTypes.func.isRequired,
  value: PropTypes.array, // eslint-disable-line
  options: PropTypes.array, // eslint-disable-line
  operators: PropTypes.array // eslint-disable-line
};

SegmentFilter.defaultProps = {
  value: [],
  options: [],
  classNamePrefix: '',
  components: null,
  selectedSegment: { name: 'Segment', uuid: '' },
  title: 'View Segments',
  className: 'tvt-filters-segments-wrapper'
};

const defaultActions = {
  onClickCreateNewSegment: openAudienceSegmentWindow,
  onClickDeleteSegment: deleteAudienceSegment
};

const mapStateToProps = null;
const mapDispatchToProps = defaultActionsForMapDispatchToProps(defaultActions);

export default connect(mapStateToProps, mapDispatchToProps)(SegmentFilter);
